import { IAddonFacebookSdkConfig } from '@domains/frontend/page-addons';


/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumLegalCookiesBannerInjectionToken {
	Config 			= 'cookies_banner_config',
	BannerCookies	= 'banner_cookies'
}


/**------------------------------------------------------
 * Interface Definitions
 */
export interface ILegalCookiesBannerModuleConfig {
	cookieExpiration	: number;					// time given in ms
	social				: {
		facebookConfig	: IAddonFacebookSdkConfig;
	};
	analytics			: {
		googleTagId		: string | null;
	};
}
